import React, { useState } from 'react';

const MineLoader =()=>{
    return(
        <div>
          <iframe src="https://giphy.com/embed/6fDQ3k4IOqnEA" width="480" height="310" frameBorder="0" class="giphy-embed" allowFullScreen></iframe><p className="header-small gradient-text-count">NFT is being minted, be ready in a few...</p>  
        </div>
    )
}

export default MineLoader;